import { MOBILE_LAYOUT_BREAKPOINT } from './constants.js';
import {
  diagramHeightForViewport,
  fitNodesToViewport,
  layoutNodesForViewport,
  measureWrapper
} from './layout.js';

export function createDiagramState(nodes) {
  return {
    offset: { x: 40, y: 40 },
    isDragging: false,
    lastMouse: { x: 0, y: 0 },
    hoveredNode: null,
    selectedNode: null,
    displayNodes: nodes,
    hasUserMovedViewport: false,
    hasCenteredLayout: false,
    scale: 1,
    dimensions: { width: 0, height: 0 },
    frame: 0,
    animationFrameId: null,
    layoutFrameId: null
  };
}

export function resizeDiagramViewport({ canvas, wrapper, ctx, nodes, state }) {
  const measuredSize = measureWrapper(wrapper);
  const width = measuredSize.width;
  const height = diagramHeightForViewport(nodes, width, measuredSize.height);
  const measured = measuredSize.measured;
  const dpr = window.devicePixelRatio || 1;

  if (width < MOBILE_LAYOUT_BREAKPOINT) wrapper.style.height = `${height}px`;
  else wrapper.style.height = '';

  canvas.width = width * dpr;
  canvas.height = height * dpr;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  state.dimensions = { width, height };
  state.displayNodes = layoutNodesForViewport(nodes, width, height);

  if (!state.hasUserMovedViewport && (measured || !state.hasCenteredLayout)) {
    const viewport = fitNodesToViewport(state.displayNodes, width, height, width < MOBILE_LAYOUT_BREAKPOINT ? 40 : 80);
    state.offset = { x: viewport.x, y: viewport.y };
    state.scale = viewport.scale;
    state.hasCenteredLayout = measured;
  }
}

export function syncDiagramCanvasSize({ canvas, wrapper, nodes, state, resize }) {
  const measuredSize = measureWrapper(wrapper);
  const width = measuredSize.width;
  const height = diagramHeightForViewport(nodes, width, measuredSize.height);
  const measured = measuredSize.measured;
  const changed = width !== state.dimensions.width || height !== state.dimensions.height;
  const needsRealCenter = measured && !state.hasCenteredLayout && !state.hasUserMovedViewport;

  if (changed || needsRealCenter) resize();
}
